import WishlistService from "@/services/WishlistService";
import Auth from "../../Auth";
import swal from "sweetalert2";
import router from "@/router";
const state = {
  items: [],
  isLoading: false,
};

const mutations = {
  SET_ITEMS(state, items) {
    state.items = JSON.parse(JSON.stringify(items || []));
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
};

const actions = {
  async fetchWishlist({ commit }) {
    commit("SET_LOADING", true);
    try {
      const response = await WishlistService.getWishlist();
      commit("SET_ITEMS", response?.data?.data?.data || []);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async addToWishlist({ commit, dispatch }, productId) {
    commit("SET_LOADING", true);
    try {
      if (!Auth.authenticated()) {
        swal
          .fire({
            title: "Please login to access your gift list",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Login",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#6d6f71",
            cancelButtonColor: "#d33",
          })
          .then((result) => {
            if (result.isConfirmed) {
              router.push("/login");
            }
          });
        return;
        return;
      }
      await WishlistService.addToWishlist(productId).then((response) => {
        if (!response.data.status.error) {
          dispatch("alert/success", response.data.status.message, {
            root: true,
          });
        }
      });
      await dispatch("fetchWishlist");
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async removeFromWishlist({ commit, dispatch }, productId) {
    commit("SET_LOADING", true);
    try {
      await WishlistService.removeFromWishlist(productId).then((response) => {
        if (!response.data.status.error) {
          dispatch("alert/success", response.data.status.message, {
            root: true,
          });
        }
      });
      await dispatch("fetchWishlist");
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async clearWishlist({ commit, dispatch }) {
    commit("SET_LOADING", true);
    try {
      await WishlistService.clearWishlist().then((response) => {
        if (!response.data.status.error) {
          dispatch("alert/success", response.data.status.message, {
            root: true,
          });
        }
      });
      await dispatch("fetchWishlist");
    } finally {
      commit("SET_LOADING", false);
    }
  },
};

const getters = {
  wishlistItems: (state) => state.items,
  wishlistCount: (state) => state.items.length,
  isLoading: (state) => state.isLoading,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
